import classNames from "classnames";
import { PropsWithChildren } from "react"
import { PropsWithClassName } from "shared/props"

import styles from './block.module.scss';

export interface BlockProps {
	title: string;
}

export const Block = (props: PropsWithChildren<BlockProps> & PropsWithClassName) => {
	return (
		<div className={classNames(props.className, styles.container)}>
			<div className={styles.header}>{ props.title }</div>
			<div className={styles.content}>{ props.children }</div>
		</div>
	)
}